/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseFinancialLangEditorViewModel } from "../types/CourseFinancialLangEditorViewModel.ts";

export const courseFinancialLangEditorViewModelSchema = z.object({
  cultureInfo: z
    .string()
    .describe(
      "Cultura do registro. Obrigatória, máximo de 10 caracteres, e não pode já estar cadastrada no plano.",
    )
    .nullish(),
  description: z
    .string()
    .describe(
      "Descrição do plano neste idioma. Obrigatória, máximo de 200 caracteres.",
    )
    .nullish(),
}) as unknown as ToZod<CourseFinancialLangEditorViewModel>;
